import { Trans } from "react-i18next";

type Props = Readonly<{
  /** A key whose text wraps the permission / reference code in <c>…</c>. */
  i18nKey: string;
  values: Record<string, string>;
}>;

/**
 * A sentence that names a permission code. The code sits in a translate="no" span, so browser page
 * translation cannot mangle PRT_SUPP_BUSINESS_EDIT.
 */
export function TransCode({ i18nKey, values }: Props) {
  return <Trans i18nKey={i18nKey} values={values} components={{ c: <span translate="no" /> }} />;
}

/** "No permission, required: <code>" (business:noPermission). */
export function MissingPermission({ code }: Readonly<{ code: string }>) {
  return <TransCode i18nKey="business:noPermission" values={{ code }} />;
}
